/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Sujith Dachepally
 * Created: 28/09/23
 */

import React from 'react';
import useWorkplanVersion from '@/components/contexts/VersionContext/useWorkplanVersion';
import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';
import SupervisorsTile from '@/components/pages/dashboard/tiles/SupervisorTile/SupervisorsTile';

const WorkplanSupervisorsTile = () => {
    const { workplanVersion, loading, error } = useWorkplanVersion();
    const { workplan } = useWorkplan();

    return (
        <SupervisorsTile
            assignment={workplan?.assignment}
            supervisors={workplanVersion?.supervisors}
            loading={loading}
            error={error}
        />
    );
};

export default WorkplanSupervisorsTile;
